import styled from "styled-components";
import { COLORS } from "../../../constants";

export const NewsBadge = styled.div`
  display: inline;
  position: relative;
  left: 30px;
  top: 10px;
  border-radius: 20px;
  background: ${COLORS.PRIMARY};
  color: ${COLORS.WHITE};
  padding: 5px;
`;